<ion-header *ngIf="headerText" mode="md" lines="none">
    <ion-toolbar mode="md" color="lightblue">
        <ng-container *ngIf="closeButtonHeader; else onlyHeaderText">
            <ion-title> {{ headerText | translate | uppercase }}</ion-title>
            <ion-buttons slot="end">
                <ion-button mode="ios" size="small" color="light" (click)="dismiss(null)">
                    <ion-icon class="bp-close"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ng-container>
        <ng-template #onlyHeaderText>
            <ion-title> {{ headerText | translate | uppercase }}</ion-title>
        </ng-template>
    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
    <div class="content" [innerHTML]="(contentText | translate)"></div>
</ion-content>
<ion-footer>
    <ion-toolbar mode="md">
        <div class="bottom">
            <ion-button mode="ios" fill="outline" size="medium" color="primary" (click)="dismiss(leftOption?.signal)">
                {{ leftOption?.text | translate }}
            </ion-button>
            <ion-button mode="ios" size="medium" color="primary" (click)="dismiss(rightOption?.signal)">
                {{ rightOption?.text | translate }}
            </ion-button>
        </div>
    </ion-toolbar>
</ion-footer>